/**
 * 环境标识
 * production 生产
 * expect 预发布
 * situation 测试
 * simulation 模拟大赛(app模拟盘)
 * development 开发
 */
import { SERVEURL } from './assetSeverUrl'
const isPro =
  process.env.NODE_ENV == "production" || process.env.NODE_ENV == "expect";
const isSit = process.env.NODE_ENV == "situation";
const isSimulation = process.env.NODE_ENV == "simulation";


const { REQUSTURL, BASE_API } = SERVEURL
const serverUrl = process.env.NODE_ENV=='dev'?BASE_API:REQUSTURL
const TOKENSEVER = process.env.NODE_ENV=='dev'?BASE_API:REQUSTURL
// const TOKENSEVER = 'https://www.cuiwjrpcvi.com'
// const TOKENSEVER = 'https://gateway-dev.cuiwjrpcvi.com'


/**
 * 首页模块
 * */
const index = {
  registerSwitch: serverUrl + '/excellent/entrance/v2/public/home/switch',
  hl: serverUrl + "/excellent/universal/v2/public/quote",
  //交易对列表
  quotationsWS:  "spot/ticker:ALL",
  quotationsmarketWS:  "spot/mini24-market-ticker:ALL",
  partition:  serverUrl+"/bsapi/a/v2/info/public/v2/web/partition",
  accountWS:  "spot/account",
  orderWS:  "spot/order",
  hotWS: 'spot/hotList:ALL',
  quotations: serverUrl + "/open/exchange/trade/quotations",
  quotationsNew: serverUrl + "/excellent/v2/public/current/market", // 币币列表数据
  area: serverUrl + "/open/exchange/trade/area/all",
  areanew: serverUrl + "/excellent/v2/public/marketingLabel", //行情标题列表
  hotSearchList: serverUrl + "/excellent/quotes/v2/public/hot", //行情热门列表
  searchAdd: serverUrl + "/open/exchange/hot/search/add",
  selectionAddDel: serverUrl + "/exchange/self/selection/add-or-delete", //老接口
  selectionAdd: serverUrl + "/exchange/self/selection/add", //老接口
  selectionList: serverUrl + "/excellent/user/v2/discretionaryDeal", //新接口,行情页面自选列表数据
  selectionListAddDel: serverUrl + "/excellent/user/v2/addOrDeleteCustomTrading", //新接口
  getMatching: serverUrl + "/open/mobile/otc/coinType/tradingMarket", //判断一键购买币种
  getPrice: serverUrl + "/otc/oneKeyMatching/avgAdvertisementPrice", //一键购买参考价
  oneKeyLimit: serverUrl + "/open/mobile/otc/oneKeyMatching/oneKeyLimit", //一键购买交易上下限
  oneKey: serverUrl + "/open/mobile/otc/coinType/oneKey", // 获取快捷方式交易币种
  recommend: serverUrl + "/open/exchange/trade/coin/recommend", //推荐接口
  banner: serverUrl + "/excellent/public/banner/v2/list", //banner接口
  isPopTaskWin: serverUrl + "/open/task/window/popup", //弹窗前调用判断是否需弹窗
  noPopTaskWin: serverUrl + "/open/task/window/cue", //点击【不再提示】时调用 不在弹出任务弹框
  publicToken: serverUrl + "/pcapi/v2/pubToken", //未登录获取端点以及token，用于ws连接
  rule: serverUrl + "/open/seckill/project/index/rule",
  enableModule: serverUrl + "/excellent/shutdown/v2/public/availableModule",
  noticeHp: serverUrl + "/open/exchange/notice/hp/get",
  candle: serverUrl + "/bsapi/a/v2/market/candles",
  status: serverUrl + "/open/mobile/otc/oneKeyMatching/status",
  mudInfo: serverUrl + "/open/contract/mud/info",
  homePopupContent: serverUrl + "/excellent/v3/public/bulletBox",
  step: serverUrl + "/open/exchange/user/index/step",
  exchangeRateHtml: serverUrl + "/open/exchange/common/exchangeRate.html",
  logout: serverUrl + '/excellent/v2/web/loginOut',
  pricingMethodSwitching: serverUrl + '/excellent/v2/public/pricingMethodSwitching',
  mailDetail: serverUrl + '/excellent/userMessage/letterInfo',
  getPartitionList: serverUrl + '/excellent/v2/public/trade/mapping/list',
  popUpBoxConfig: serverUrl + '/excellent/public/contest/popUpBoxConfig', // 模拟合约弹窗
  getLanguageConfig: serverUrl + '/excellent/common/v2/public/getLanguageConfig', // 获取多语言配置列表
  appDownLoadSwitch: serverUrl + '/excellent/common/v2/public/appDownLoadSwitch', // 新 app 下载入口开关：0关闭 1开启
  appVersionList: serverUrl + '/excellent/public/release/appVersionList', // app 下载版本列表
};


// /**
//  * 合约相关接口
//  * 
//  * */
const swap = {
  //交易对列表 https://futuresapi.biking.tv 会在上线build前通过脚本replaceUrl.js文件进行替换。替换内容来自oss配置
  symbollist: isPro //生产
    ? `${REQUSTURL}/market/api/v2/pub/getPricesTicker`
    : isSit //测试
      ? `${REQUSTURL}/market/api/v2/pub/getPricesTicker`
      : isSimulation //模拟大赛
        ? "https://futuresapi.cwfutures.info/market/api/v2/pub/getPricesTicker"
        : `${REQUSTURL}/market/api/v2/pub/getPricesTicker`, //本地
  kline3d: isPro //生产
    ? `${REQUSTURL}/market/api/v2/pub/marketKlines`
    : isSit //测试
      ? `${REQUSTURL}/market/api/v2/pub/marketKlines`
      : isSimulation //模拟大赛
        ? "https://futuresapi.cwfutures.info/market/api/v2/pub/getPricesTicker"
        : `${REQUSTURL}/market/api/v2/pub/marketKlines`, //本地
};

const task = {
  taskList: serverUrl + "/open/data/task/getTaskList",
  taskLq: serverUrl + "/open/data/task/claimedTask",
  userTask: serverUrl + "/open/data/task/getUserTask",
};

/**
 * 抢购模块
 * */
const fansup = {
  ascrollMessagee: serverUrl + "/open/seckill/project/scroll-message",
  // currentInfo: "/open/seckill/project/current-info",
  currentInfo: serverUrl + "/open/seckill/project/top-info",
  historyInfo: serverUrl + "/open/seckill/project/all/history-info",
  baseInfo: serverUrl + "/open/seckill/user/base-info",
  rounds: serverUrl + "/open/seckill/project/rounds",
  detail: serverUrl + "/open/seckill/project/detail",
  calc: serverUrl + "/seckill/pay/calc",
  pay: serverUrl + "/seckill/pay",
  allRecords: serverUrl + "/seckill/user-project/all-records",
  roundRecords: serverUrl + "/seckill/user-project/round-records",
  allCurrentInfo: serverUrl + "/open/seckill/project/all/current-info",
  buy: serverUrl + "/seckill/async/buy", // 抢购下单
  cancel: serverUrl + "/seckill/async/cancel", // 取消抢购下单
  asyncPay: serverUrl + "/seckill/async/pay", // 支付请求
  asyncQuery: serverUrl + "/seckill/async/query/", // 查询抢购状态
  saveEvaluating: serverUrl + "/open/seckill/project/survey/options", // 保存评测
  subOrder: serverUrl + "/seckill/lottery/apply/orders", //申请摇号 订单查询
  targetOrder: serverUrl + "/seckill/lottery/confirm/orders", //申请摇号 我的查询
  orderDetail: serverUrl + "/seckill/lottery/order/lottery", //申请摇号 查看签号
};

/**
 * 用户模块
 * */
const user = {
  getAndroidUrl: serverUrl + '/excellent/common/v2/public/getAndroidDownLoadUrl',
  getSuperSign: serverUrl + '/excellent/common/v2/public/getIosSuperSign',
  getQrCode: serverUrl + '/excellent/v2/public/getLoginQrCode',
  getLoginResult: serverUrl + '/excellent/v2/public/scanLoginQuery',
  firstEditPassword: serverUrl + '/excellent/user/v2/setPassword',
  registerGoogle: serverUrl + '/excellent/google/v2/public/web/googleRegister',
  bindGoogleAccount: serverUrl + '/excellent/google/v2/public/web/googleBind',
  validGoogleAccount: serverUrl + '/excellent/google/v2/public/web/googleBindVerify',
  validGoogelPassword: serverUrl + '/excellent/google/v2/public/web/googleBindPasswordVerify',
  googleLogin: serverUrl + '/excellent/google/v2/public/web/googleLogin',
  markAllRead: serverUrl + '/excellent/userMessage/v2/markAllRead',
  clearAllUnread: serverUrl + '/excellent/userMessage/v2/clearAllUnread',
  topsInfo: serverUrl + "/excellent/seckill/user/v2/public/wealth/info",
  topsInfo2: serverUrl + "/excellent/personal/v2/information",
  // userToken: serverUrl + "/open/exchange/user/token",
  userToken: serverUrl + "/excellent/public/webUser/token/v2/get",
  userLogin: serverUrl + "/excellent/v2/public/web/login",
  userInfo: serverUrl + "/excellent/user/v2/info",
  userTop: serverUrl + '/excellent/user/v2/topInfo',
  userMessage: serverUrl + '/excellent/userMessage/v2/public/list',
  changePhoneNum: serverUrl + '/excellent/user/v2/changePhoneNum',
  editPassword: serverUrl + '/excellent/user/v2/changePassword',
  setGoogleCaptcha:serverUrl + '/excellent/user/v2/setGoogleCaptcha',
  bindMail: serverUrl + '/excellent/user/v2/bindEmail',
  loginLog: serverUrl + '/excellent/user/v2/loginLog',
  pricingMethodSwitching: serverUrl + '/excellent/v2/public/pricingMethodSwitching',
  sendEmail: serverUrl + '/excellent/v2/public/forgetPassword/sendEmail',
  register: serverUrl + '/excellent/v2/public/web/register/complete',
  totalSendCode: serverUrl + '/excellent/common/v2/public/sendValidateCode',
  validCode: serverUrl + '/excellent/common/v2/public/verifyValidateCode',
  validRegister: serverUrl + '/excellent/v2/public/web/register/verify',
  resetPassword: serverUrl + '/excellent/user/v2/public/resetPasswordByEmail',
  resetPasswordWithCode: serverUrl + '/excellent/user/v2/public/resetLoginPassword',
  resetTradePassword: serverUrl + '/excellent/user/v2/resetTradePassword',
  getGoogleSecret: serverUrl + '/excellent/user/v2/getGoogleSecret',
  editorBindEmail: serverUrl + '/excellent/user/v2/changeEmail',
};

const fifa = {
  getTask: serverUrl + '/fifa/task/public/getTask',
  getPoints: serverUrl + '/fifa/points/user',
  formTeam: serverUrl + '/fifa/user/formTeam',
  getUserInfo: serverUrl + '/fifa/user/info',
  contributionNumberList: serverUrl + '/fifa/user/contribution/number/list',
  contributionTeamList: serverUrl + '/fifa/user/contribution/team/list',
  getInfo: serverUrl + '/fifa/public/setting/getInfo',
  getPoolInfo: serverUrl + '/fifa/public/setting/pool/getInfo',
  getPoolAllocateList: serverUrl + '/fifa/poolAllocate/public/list',
  getCountryList: serverUrl + '/fifa/event/public/countryList',
  getQuizChampion: serverUrl + '/fifa/event/public/getQuizChampion',
  quizChampion: serverUrl + '/fifa/event/quizChampion',
  getEventList: serverUrl + '/fifa/event/public/eventList',
  quizEvent: serverUrl + '/fifa/event/quizEvent',
  getQuizEventRecord: serverUrl + '/fifa/event/quizEventRecord',
  getGoodsList: serverUrl + '/fifa/goods/public/goodsList',
  exchangeGoods: serverUrl + '/fifa/goods/exchange',
  getExchangeRecord: serverUrl + '/fifa/goods/exchangeRecord',
  getUserBonus: serverUrl + '/fifa/user/bonus',
  getUserRankList: serverUrl + '/fifa/public/rank/user/list',
  getTeamRankList: serverUrl + '/fifa/public/rank/team/list',
};

/**
 * OTC模块
 * */
const otc = {
  validPayWay: serverUrl + '/excellent/otc/advertisement/v2/getMatchPayment',
  getAdLimitInfo: serverUrl + '/excellent/otc/merchant/advertisement/v2/limit',
  getFiatCurrencyList: serverUrl + '/excellent/otc/fiat/v2/public/fiatsForAdvertisement',
  getPayMethodList: serverUrl + '/excellent/otc/user/payment/v2/public/paymentForFiat',
  checkCoinDialogs: serverUrl + '/excellent/v2/public/checkDialogs',
  getPayByAdvertisementId: serverUrl + '/excellent/otc/advertisement/v2/getMatchPayWay',
  getProfitAccount: serverUrl + '/excellent/user/v2/personalCenterPersonalInformation',
  getCardCoinList: serverUrl + '/excellent/public/otc/itez/v2/pairs', // 信用卡获取币种；
  getFiatList: serverUrl + '/excellent/public/otc/creditCard/v2/fiatList', // 快捷支付法币列表接口
  getCryptoList: serverUrl + '/excellent/public/otc/creditCard/v2/cryptoList', // 快捷支付加密货币列表接口
  getPayments: serverUrl + '/excellent/public/otc/creditCard/v2/payments', // 快捷支付币对单价等信息接口
  onramp: serverUrl + '/excellent/otc/creditCard/v2/onramp', // 购买加密货币接口
  uploadOrder: serverUrl + '/excellent/public/otc/creditCard/v2/uploadOrder', // 快捷支付上传订单号接口
  addBasicMargin: serverUrl + '/excellent/audit/v2/increase',
  setCreditCardOrder: serverUrl + '/excellent/otc/itez/v2/orderedId',
  setMobileCreditCardOrder: serverUrl + '/excellent/app/otc/itez/v2/orderedId',
  getCreditCardOrder: serverUrl + '/excellent/otc/itez/v2/order/list',
  getorderList: serverUrl + '/excellent/public/otc/creditCard/v2/orderList', //快捷支付获取交易列表接口
  getSignature: serverUrl + '/excellent/otc/itez/v2/run',
  getcreditCardSignature: serverUrl + '/excellent/public/otc/creditCard/v2/sign', //快捷支付参数签名接口,
  signBuy: serverUrl + '/excellent/otc/creditCard/v2/signBuy', //快捷支付参数签名接口
  signSell: serverUrl + '/excellent/otc/creditCard/v2/signSell', //
  

  
  getMobileSignature: serverUrl + '/excellent/app/otc/itez/v2/run',
  quickOrderDetail: serverUrl + '/excellent/otc/biya/v2/order/detail',
  updownList: serverUrl + '/excellent/v2/public/gain/list',
  fastBuyCoin: serverUrl + '/excellent/otc/biya/v2/order',
  tradeMatch: serverUrl + '/excellent/otc/fiatQuickly/v2/tradeMatch', //OTC - 快捷交易匹配
  
  getCoinPrices: serverUrl + '/excellent/public/otc/biya/v2/prices',
  orderList: serverUrl + "/mobile/otc/order/page", //otc 用户或者商家订单列表
  getOrder: serverUrl + "/mobile/otc/order/get", //订单详情
  appealCancel: serverUrl + "/mobile/otc/complaint/cancel", //取消申诉
  getUserInfo: serverUrl + "/mobile/otc/user/get", //获取用户信息
  getMerchantInfo: serverUrl + "/open/mobile/otc/merchant", //获取商家信息
  getAdvertisement: serverUrl + "/open/mobile/otc/advertisement/page", //广告页列表查询
  getOtcUserAsset: serverUrl + "/mobile/otc/user/asset/otcUserAsset", //当前登陆用户OTC法币资产
  assetsTransf: serverUrl + "/mobile/otc/user/asset/transfer", //法币币币账户资金互转
  assetsRecord: serverUrl + "/account/transfer/record", //"/mobile/otc/user/asset/page", //分页查询用户法币资产划转记录列表
  getOrderDetail: serverUrl + "/mobile/otc/order/get", //获取订单详情
  uploadFile: serverUrl + "/user/uploadFile", //上传图片
  getAds: serverUrl + "/open/mobile/otc/advertisement/page", // 获取出售首页广告列表
  getCoinType: serverUrl + "/open/mobile/otc/coinType", // 获取出售首页币种信息
  appealAdd: serverUrl + "/mobile/otc/complaint/add", //新增申诉单
  otcUserAsset: serverUrl + "/mobile/otc/user/asset/otcUserAsset", // 当前登录用户otc资产
  addOrder: serverUrl + "/mobile/otc/order/add", // 下单
  checkUser: serverUrl + "/mobile/otc/user/check", // 检测用户是否设置基本信息
  checkUserLimt: serverUrl + "/mobile/otc/order/checkUser", // 检查用户是否有下单限制
  activityOrder: serverUrl + "/mobile/otc/order/activityOrder", // 进行中的订单
  confirmReceipt: serverUrl + "/mobile/otc/order/release", // 确认收款
  cancelOrder: serverUrl + "/mobile/otc/order/cancel", // 取消订单

  getPayAccountList: serverUrl + "/mobile/otc/pay-account/page", // 获取收款账号信息
  changePayAccountEbabled: serverUrl + "/mobile/otc/pay-account/enabled", // 启用支付状态
  changePayAccountDisabled: serverUrl + "/mobile/otc/pay-account/disabled", // 禁用支付状态
  upload: serverUrl + "/mobile/file/upload", // 单独图片上传接口
  getPayAccount: serverUrl + "/mobile/otc/pay-account/get", // 获取收款账号的详细信息
  addPayAccount: serverUrl + "/mobile/otc/pay-account/add", // 添加收款账号的信息
  updataPayAccount: serverUrl + "/mobile/otc/pay-account/update", // 更新收款账号的信息
  deletaPayAccount: serverUrl + "/mobile/otc/pay-account/delete", // 删除收款账号的信息
  getBankName: serverUrl + "/mobile/otc/config/banks", // 获取所有银行名称数据
  getAreaCode: serverUrl + "/mobile/otc/config/countries", // 获取国家及区号
  bindPhone: serverUrl + "/user/validatePhone.html", // 绑定手机号码
  sendMsg: serverUrl + "/excellent/common/v2/public/sendValidateCode", // 发送手机验证码
  modifyPwd: serverUrl + "/user/modifyPwd.html", // 修改交易密码
  setNickName: serverUrl + "/mobile/otc/user/setNickName", // 设置昵称
  confirmPayed: serverUrl + "/mobile/otc/order/payed", // 确认付款
  getOrderQuantity: serverUrl + "/mobile/otc/order/statisticsOrderQuantity", //统计进行中的用户、商家订单数量

  //广告管理
  getAdList: serverUrl + "/mobile/otc/ad/page", //获取广告列表
  offAdver: serverUrl + "/mobile/otc/ad/user-cancel", //下架广告
  upAdver: serverUrl + "/mobile/otc/ad/user-putAway", //上架广告
  checkBeforePutAway: serverUrl + "/mobile/otc/ad/before-user-putAway", //上架前-的关联帐号检测
  delAdver: serverUrl + "/mobile/otc/ad/del", //删除广告
  getAdDetail: serverUrl + "/mobile/otc/ad/get", //获取广告详情
  getPushConfig: serverUrl + "/mobile/otc/ad/pushConfig", //发布广告所需的配置信息
  pushAd: serverUrl + "/mobile/otc/ad/save", //发布广告保存
  editValidate: serverUrl + "/mobile/otc/ad/update/validate", //列表点击编辑的验证

  //face认证
  getFaceIdURL: serverUrl + "/mobile/otc/order/getFaceIdURL", //获取faceID URL
  faceIdResult: serverUrl + "/mobile/otc/order/faceIdResult", //获取faceID URL
  isBlack: serverUrl + "/mobile/otc/order/isBlack", //判断当前用户是否被加入黑名单

  payCurrency: serverUrl + "/data/open/otc/advertisement/payCurrency", //发布广告获取对应的法币币种
  marketPrice: serverUrl + "/data/open/otc/advertisement/marketPrice", //发布广告汇率
  
  // 商户列表
  merchantList: serverUrl + '/excellent/otc/advertisement/v2/public/listOnlineForPage',
  biyaOrderList: serverUrl + '/excellent/otc/biya/v2/order/list',
  // 下单列表
  placeAnOrder: serverUrl + '/excellent/otc/order/v2/addOrder',
  otcUserInfo: serverUrl + '/excellent/otc/home/v2/information',
  addPay: serverUrl + '/excellent/pay/account/v2/expansion',
  getBankType: serverUrl + '/excellent/otc/v2/public/sk',
  payList: serverUrl + '/excellent/pay/account/v2/findPage',
  // OTC3.0 - 查询用户支付方式集合
  listUserPaymentByFiat: serverUrl + '/excellent/otc/user/payment/v2/listUserPaymentByFiat',
  changePayStatus: serverUrl + '/excellent/pay/account/v2/update/consciousness',
  //  OTC3.0 - 删除用户支付方式
  delUserPayment: serverUrl + '/excellent/otc/user/payment/v2/delUserPayment',
  updatePay: serverUrl + '/excellent/pay/account/v2/forUpdate',
  // OTC3.0 - 保存用户支付方式
  saveUserPayment: serverUrl + '/excellent/otc/user/payment/v2/saveUserPayment',
  uploadImg: serverUrl + '/excellent/user/v2/upload',
  uploadVideo: serverUrl + '/excellent/user/v2/video/upload',
  // // 订单列表；
  // orderListOtc: serverUrl + '/excellent/otc/user/order/orderList',
  getPubInfo: serverUrl + '/excellent/advertisement/v2/pushSkip',
  publish: serverUrl + '/excellent/otc/merchant/advertisement/v2/newSave',
  getAdvertisementList: serverUrl + '/excellent/otc/merchant/advertisement/v2/listByMerchantSelf',
  getCountInfo: serverUrl + '/excellent/otc/finance/v2/order/info',
  getOrderList: serverUrl + '/excellent/otc/user/order/v2/list',
  download: serverUrl + '/excellent/otc/user/order/v2/verifyExportTimes',
  orderInfo: serverUrl + '/excellent/order/v2/orderInfo',
  updateOrderStatus: serverUrl + '/excellent/otc/user/order/v2/getStatusById',
  cacelOrderAppeal: serverUrl + '/excellent/otc/user/order/v2/complaint/cancel',
  payConfirmation: serverUrl + '/excellent/otc/user/order/v2/payConfirmation',
  cacelOrder: serverUrl + '/excellent/otc/user/order/v2/cancel',
  appeal: serverUrl + '/excellent/complaint/v2/add/appeal',
  releaseCoins: serverUrl + '/excellent/order/v2/loan',
  getCoinsPrice: serverUrl + '/excellent/common/v2/public/getOtcRateByCmc',
  getValidateImage: serverUrl + '/excellent/image/v2/public/validate',
  getMerchantInfoByWeb: serverUrl + '/excellent/otc/user/v2/getMerchantInfo',
  getAdUser: serverUrl + '/excellent/otc/user/v2/merchantInfo',
  downloadBill: serverUrl + '/excellent/otc/finance/v2/financialReport',
  getMerchantLevel: serverUrl + '/excellent/otc/org/v2/becomeMerchantInfo',
  getYxConfig: serverUrl + '/excellent/otc/home/v2/public/pointing',
  submitMerchantCertification: serverUrl + '/excellent/otc/org/v2/send/dingTalk',
  takeOff: serverUrl + '/excellent/advertisement/v2/cancelOrder',
  takeOn: serverUrl + '/excellent/advertisement/v2/release/userPutaway',
  validDeleteAd:serverUrl + '/excellent/advertisement/v2/delete/verify',
  deleteAd: serverUrl + '/excellent/advertisement/v2/delete/',
  validUpdate: serverUrl + '/excellent/advertisement/v2/edit/examine',
  updateAdv: serverUrl + '/excellent/advertisement/v2/edit',
  getInfoByAvdId: serverUrl + '/excellent/otc/merchant/advertisement/v2/getByIdForMerchant',
  getPrimaryMerchantInfo: serverUrl + '/excellent/otc/org/v2/merchantReveal',
  addMargin: serverUrl + '/excellent/audit/v2/margin/append',
  reduceMargin: serverUrl + '/excellent/audit/v2/reduce',
  marginInfo: serverUrl + '/excellent/audit/v2/margin/info',
  selectPay: serverUrl + '/excellent/otc/user/order/v2/selectPayWay',
  getConfig: serverUrl + '/excellent/flashExchange/conf/getConfig/match', //闪兑 - 闪兑配置conf/public/getConfig/default
  getPublicConfig: serverUrl + '/excellent/flashExchange/conf/public/getConfig/match', //闪兑 - 闪兑配置
  getdefault: serverUrl + '/excellent/flashExchange/conf/getConfig/default', //闪兑 - 闪兑配置
  getpublicdefault: serverUrl + '/excellent/flashExchange/conf/public/getConfig/default', //闪兑 - 闪兑配置

  confirmPublicSymbol: serverUrl + '/excellent/flashExchange/conf/public/getConfig/symbol',  //确认base、quote;public
  confirmSymbol: serverUrl + '/excellent/flashExchange/conf/getConfig/symbol', // 确认base、quote;
  getRate: serverUrl + '/excellent/flashExchange/conf/getRate', //闪兑 - 闪兑汇率查询
  flashExchangpage: serverUrl + '/excellent/flashExchange/order/page', //分页查询闪兑记录
  flashExchangecreate: serverUrl + '/excellent/flashExchange/order/create', //闪兑项目 - 创建订单
  flashExchangequote: serverUrl + '/excellent/flashExchange/order/quote', //闪兑项目 - 闪兑汇率新
  flashPublicExchangequote: serverUrl + '/excellent/flashExchange/order/public/quote', //闪兑项目 - 闪兑汇率新 public
};
/**
 * 官方验证
 * */
const validate = {
  validate: serverUrl + "/open/official/validate",
  notice: serverUrl + "/open/exchange/notice/office/get",
};

/**
 * 红包
 * */
const redPackets = {
  notakenList: serverUrl + "/open/redenvelope/notaken/list", // 获取未领取红包列表
  takenList: serverUrl + "/redenvelope/notaken/list", // 获取登录后的红包列表
  condition: serverUrl + "/redenvelope/taken/condition", //获取用户领取条件
  getToken: serverUrl + "/redenvelope/op/getToken", //获取红包token
  taken: serverUrl + "/redenvelope/op/taken", //领取红包
  takenNewUser:  serverUrl + "/redenvelope/op/takenNewUser", //离线领取登录后加载到登录用户
  get: serverUrl + "/open/redenvelope/get", //分享链接id查询红包列表
};

/**
 * 杠杆模块
 * */
const margin = {
  openMargin: serverUrl + "/margin/account/register", //开通杠杆
  marginAsset: serverUrl + "/lever/asset", //杠杆划转账户信息
  withdrawNum: serverUrl + "/margin/trade/withdrawNum", //当前币种可用
  transfer: serverUrl + "/lever/transfer", //划转
  transferRecord: serverUrl + "/account/transfer/record", //"/margin/phoneTransferRecord", //划转记录
  getBorrow: serverUrl + "/margin/queryBorrowcoins", //申请借币基础信息
  borrowcoins: serverUrl + "/margin/borrowcoins", //借币
  repay: serverUrl + "/margin/query/repay", //还币基础信息
  repayCoins: serverUrl + "/margin/unify/repay", //还币
  marginRecord: serverUrl + "/margin/jourposi", //借币还币记录
  forceRecord: serverUrl + "/margin/page/forcedRecords", //强平记录
  orderList: serverUrl + "/margin/page/orders", //委托
  cancelOrder: serverUrl + "/margin/trade/orderCancel", //撤销当前委托
  coinsName: serverUrl + "/margin/trade/symbol", //获取所有币种
  isOpenMargin: serverUrl + "/margin/account/info", //查询杠杆账户是否开通
  safetyDegree: serverUrl + "/margin/trade/safetyDegree", //查询杠杆账户安全度
  wsOrder: serverUrl + "/user/queue/margin.order", //socket当前委托
  wsSafe: serverUrl + "/user/queue/margin.marginsafe", //socket风险率
  symbolDir: serverUrl + "/margin/trade/symbolDir", //币种列表
  addFollow: serverUrl + "/margin/trade/updateFollowSymbolDir", //收藏自选切换
  followSymbol: serverUrl + "/margin/trade/batchAddFollowSymbolDir", //登录后查看用户是否添加收藏
  balances: serverUrl + "/margin/trade/balances", //当前用户持仓
  symboldirRule: serverUrl + "/margin/trade/symboldirRule", //交易币对规则
  feeRatio: serverUrl + "/margin/trade/feeRatio", //查询交易所手续费率
  orderPlace: serverUrl + "/margin/trade/orderPlace", //下单
  cancelAll: serverUrl + "/margin/orders/batch/cancel", //当前委托一键撤销
};

/**
 * 币赢理财
 * */
const financial = {
  list: serverUrl + "/open/regular/financial/list", //定期理财-产品列表
  hold: serverUrl + "/regular/financial/hold", //定期理财-我的持仓
  buy: serverUrl + "/regular/financial/buy", //定期理财-产品购买
  detail: serverUrl + "/open/regular/financial/detail", //定期理财 - 产品详情查询接口
  balance: serverUrl + "/regular/user/account", //币币账户当前币种余额
  account: serverUrl + "/regular/financial/account", //定期理财-资产折合,
  // getInfo: serverUrl + "/system/financial/product/getInfo", //定期理财-产品信息,(todo::: 旧接口)
  getInfoDetail: serverUrl + "/system/financial/product/getInfoDetail", //定期理财-理财产品信息详情
  applyFinancial: serverUrl + "/system/financial/product/applyFinancial", //定期理财-申购
  redemption: serverUrl + "/system/financial/product/redemption", //定期理财-赎回
  investList: serverUrl + "/system/financial/user/invest/list", //定期理财-投资列表
  headerInfo: serverUrl + "/system/financial/product/headerInfo", //定期理财-理财头部信息
  recordList: serverUrl + "/system/financial/user/invest/record/list", //定期理财-理财头部信息
  settlementRecords: serverUrl + "/system/financial/user/invest/record/settlement", //定期理财-理财头部信息
  settlement: serverUrl + '/system/financial/user/invest/record/pc/settlement', // 结算清单明细
  propertyDetails: serverUrl + '/system/financial/user/invest/detail', // 资产理财产品详情
  settlementDetails: serverUrl + '/system/financial/user/invest/record/settlement/detail',
  getInfo: serverUrl + '/system/financial/product/getFeatured', // 定期理财-产品信息
  getAllInfo: serverUrl + '/system/financial/product/getAllInfo', // 所有产品列表
  getProductInfo: serverUrl + '/system/financial/product/getInfo2', // 活期定期产品
  
};

/**
 * 币币交易
 * */
const proTrading = {
  getLastePrice: serverUrl + '/spot-o/open/api/v2/market/getDexPrice',
  dexWs: 'wss://dexws-test.cuiwjrpcvi.com',
  quotationsWS: "spot/ticker:ALL",
    quotationsmarketWS:  "spot/mini24-market-ticker:ALL",
    marketdickerCoinWS:  "spot/market-ticker:",
  quotations: serverUrl + "/open/exchange/trade/quotations", // 币种列表
  quotationsNew: serverUrl + "/excellent/v2/public/current/market",
  area: serverUrl + "/open/exchange/trade/area/all", // 分区
  selectionAddDel: serverUrl + "/exchange/self/selection/add-or-delete", // 老接口
  selectionList: serverUrl + "/excellent/user/v2/discretionaryDeal", //新接口
  selectionListAddDel: serverUrl + "/excellent/user/v2/addOrDeleteCustomTrading", //新接口
  areaCoins: serverUrl + "/open/exchange/trade/area/coins", // 交易市场币种
  newarea: serverUrl + "/excellent/v2/public/trade/mapping/list", //新分区接口
  spotCoins: serverUrl + "/excellent/internal/public/currencyInfo",
  countrys: serverUrl + "/excellent/common/v2/public/querySupportedCountries",
  contractShow: serverUrl + "/excellent/public/contract/v2/display",
  sysConfig: serverUrl + "/excellent/system/v2/public/parameter",
  getCurrencyInfo: serverUrl + '/excellent/internal/v2/public/currencyDetail',
  getCoinPairInfo: serverUrl + '/spot-o/open/api/v2/market/getDexPairs',
  getPairInfoList: serverUrl + '/excellent/internal/public/trades',
  queryOfficialVerify: serverUrl + '/excellent/common/v2/public/queryOfficialVerify'
};

/**新资产接口 */
const newFinancial = {
  giveCoinInfo: serverUrl + "/data/task/giveCoinInfo.html",
  grantGiveCoin: serverUrl + "/data/task/grantGiveCoin.html",
  contractMudTransfer: serverUrl + "/contract/mud/contractMudTransfer",
  transfer: serverUrl + "/account/transfer",
  amount: serverUrl + "/account/transfer/amount",
  data: serverUrl + "/account/transfer/data",
  getOperationRecord: serverUrl + "/account/getOperationRecord.html",
  getHyperpayRecords: serverUrl + "/financial/getHyperpayRecords.html",
  airdropAwardList: serverUrl + "/account/airdropAwardList.html",
  cancelWithdrawBtc: serverUrl + "/account/cancelWithdrawBtc.html",
  coinNodeUserList: serverUrl + "/coins/coinNodeUserList.html",
  saveCoinNodeUser: serverUrl + "/coins/saveCoinNodeUser.html",
  showCoinNodeLog: serverUrl + "/coins/showCoinNodeLog.html",
  relieveCoinUser: serverUrl + "/coins/relieveCoinUser.html",
  nodePlan: serverUrl + "/account/v2/coins/nodePlan",
};

/** earn */
const earn = {
  financialList: serverUrl + "/financial/v1/invest/getFinancialList",
  privateToken: serverUrl + "/pcapi/v2/priToken", //已登录获取端点以及token，用于ws连接
  profitInfo: serverUrl + "/financial/v1/invest/getProfitlInfo",
  financialHtml: serverUrl + "/financial/index.html?tab=6"
}


/**
 * merchandiser
 */
const merchandiser = {
  queryProfit: TOKENSEVER + '/copytrading/api/v2/client/leader/queryProfit', //今日收益、累计收益，头像，昵称，签名
  followProfit: TOKENSEVER + '/copytrading/api/v2/setting/profit', //今日收益、累计收益，头像，昵称，签名
  currentFollowList: TOKENSEVER + '/copytrading/api/v2/setting/cOrderList', //当前跟单
  historyFollowList: TOKENSEVER + '/copytrading/api/v2/setting/hOrderList', //历史跟单
  myLeaderList: TOKENSEVER + '/copytrading/api/v2/setting/list', //获取我的交易员列表
  leaderShare: TOKENSEVER + '/copytrading/api/v2/setting/traderProfit', //交易员分成
  fetchRingoutOne: TOKENSEVER + '/contract/api/v2/trade/order/close-position', //平仓
  tyjStopProfitsLoss: TOKENSEVER + '/v1/futuresc/simulated/trade', //体验金修改止盈止损
  moveStopProfitsLoss: TOKENSEVER + '/contract/api/v2/trade/order/order-move-profit-loss', //修改移动止盈止损
  stopProfitsLoss: TOKENSEVER + '/contract/api/v2/trade/order/order-profit-loss', //修改止盈止损
  getMerchandiserGetUserProfit: TOKENSEVER + '/copytrading/api/v2/client/leader/queryProfit', //获取交易员相关信息
  getMerchandiserGetUserInfo: TOKENSEVER + '/copytrading/api/v2/client/leader/query', //获取用户信息
  getMerchandiserInstruments: TOKENSEVER + '/copytrading/api/v2/client/leader/pairs', //获取币对列表
  getMerchandiserGetCurrentPositionList: TOKENSEVER + '/copytrading/api/v2/client/leader/cOrderList', //交易员当前带单
  getMerchandiserGetHistoryPositionList: TOKENSEVER + '/copytrading/api/v2/client/leader/hOrderList', //交易员历史带单
  getMerchandiserSetStatus: TOKENSEVER + '/copytrading/api/v2/client/leader/enable', //交易员设置带单状态
  getMerchandiserGetTransactionData: TOKENSEVER + '/copytrading/api/v2/pub/leader/data', //交易员的交易数据
  getMerchandiserGetLeaderConfig: TOKENSEVER + '/copytrading/api/v2/client/leader/querySetting', //获取带单设置
  getMerchandiserLeaderConfig: TOKENSEVER + '/copytrading/api/v2/client/leader/setting', //带单设置
  getMerchandiserGetFollowList: TOKENSEVER + '/copytrading/api/v2/client/leader/queryFList', //正在跟随和历史跟随
  getMerchandiserStopFollow: TOKENSEVER + '/copytrading/api/v2/client/leader/cancelUser', //取消用户跟随
  getMerchandiserSettingLeaderDetail: TOKENSEVER + '/copytrading/api/v2/pub/leader/info', //带单老师详情
  getMerchandiserFollowSettingEcho: TOKENSEVER+ '/copytrading/api/v2/setting/get', //修改带单设置回显
  getMerchandiserSetting: TOKENSEVER+ '/copytrading/api/v2/setting', //设置带单设置
  getMerchandiserCancelFollow: TOKENSEVER+ '/copytrading/api/v2/setting/exit', //取消跟随
  getMerchandiserAccountDetail: TOKENSEVER + '/copytrading/api/v2/setting/userAccount', //账户详情
  getFollowLeverageRange: TOKENSEVER + '/copytrading/api/v2/setting/getFollowLeverageRange', //选中币对的杠杆范围
  getFollowTotalAmount: TOKENSEVER + '/copytrading/api/v2/setting/getFollowTotalAmount', //获取跟单保证金
  editFollowTotalAmount: TOKENSEVER + '/copytrading/api/v2/setting/editFollowTotalAmount', //修改跟单保证金
  getDocumentaryStatus: TOKENSEVER + '/copytrading/api/v2/setting/getFollowSign', //跟单协议状态
  setDocumentaryStatus: TOKENSEVER + '/copytrading/api/v2/setting/setFollowSign', //设置跟单协议状态
  applyLeader: TOKENSEVER +  "/copytrading/api/v2/client/leader/reqLeader", //申请成为交易员
  // getCountryPhoneCodeList: TOKENSEVER +  "/copytrading/api/v2/client/leader/getCountryPhoneCodeList", //获取区号列表
  getCountryPhoneCodeList: TOKENSEVER +  "/excellent/common/v2/public/querySupportedCountries", //获取区号列表
  rotationChart: TOKENSEVER +  "/copytrading/api/v2/pub/leader/rotationChart", //获取首页轮播图
  leaderList: TOKENSEVER +  "/copytrading/api/v2/pub/leader/query", //获取交易员老师列表
  leaderCurrentFollowList: TOKENSEVER +  "/copytrading/api/v2/pub/leader/cOrderList", //获取交易员老师列表
  leaderDetail: TOKENSEVER +  "/copytrading/api/v2/pub/leader/info", //交易详情
  leaderFollow: TOKENSEVER +  "/copytrading/api/v2/pub/leader/followers", //跟随者
  leaderHistoryFollowList: TOKENSEVER +  "/copytrading/api/v2/pub/leader/hOrderList", //订单-历史带单
  vacancyRemind: TOKENSEVER +  "/copytrading/api/v2/pub/leader/vacancyRemind", //空位提醒
  instruments: TOKENSEVER +  "/contract/api/v2/public/ins", //合约列表
  urlInfo: TOKENSEVER +  "/contract/api/v2/public/url-info", //空位提醒
  getTransferList: TOKENSEVER + '/copytrading/api/v2/setting/queryTransferList', // 划转记录
  accountTransfer: TOKENSEVER + '/copytrading/api/v2/setting/transfer', // 合约跟单互转
  queryFollowAmountIntroductionList: TOKENSEVER + '/copytrading/api/v2/client/leader/queryFollowAmountIntroductionList', // 查询交易员带单简况
  queryFollowAmountIntroductionAmount: TOKENSEVER + '/copytrading/api/v2/client/leader/queryFollowAmountIntroductionAmount', // 查询交易员带单简况
}

/**
 * 资产账户
 */
const property = {
  getSpotAccountFinancialRecord: serverUrl + '/bsapi/a/v2/account/assets/record/page', // 现货财务记录
  getDocumentaryRecord: serverUrl + '/copytrading/api/v2/setting/followBills', // 跟单记录
  getBonusRecord: serverUrl + '/contract/api/v2/simulated/order/bills', // 赠金记录
  getContractFinancialRecord: serverUrl + '/contract/api/v2/trade/account/bills', // 合约记录
  getCoinRecord: serverUrl + '/excellent/account/v2/rechargeRecord', // 充币，获取记录
  creatCoinAddress: serverUrl + '/excellent/account/v2/createAddress', // 充币，创建地址
  getCoinNetWork: serverUrl + '/excellent/account/v2/public/getRechargeCoins', // 充币，获取币种和网络
  getAllAssetBalance: serverUrl + '/excellent/user/v2/personalCenterPersonalInformation', // 资产总览账户余额
  findPage: serverUrl + '/excellent/user/asset/v2/findPage', // 资产动态
  getPageOperationRecord: serverUrl + '/excellent/user/v2/getPageOperationRecord', // 资产充值及提现列表
  transferRecordList: serverUrl + '/excellent/account/handle/v2/transfer/archives', // 划转记录
  getRechargeAddress: serverUrl + '/excellent/account/v2/getRechargeAddress', // 获取充值地址
  // getRechargeAddress: serverUrl + '/excellent/user/v2/getPageOperationRecord', // 获取充值地址
  getAccountList: serverUrl + '/excellent/account/handle/v2/catalog', // 获取币种列表
  getAssets: serverUrl + '/excellent/financial/v2/extract',
  addWithdrawalAddress: serverUrl + '/excellent/user/v2/modifyWithdrawalAddress', // 添加提币地址
  withdrawalAmount: serverUrl + '/excellent/account/v2/withdrawCoins', //提现
  getAccountTransferList: serverUrl + '/excellent/account/handle/v2/transfer/data', // 互转账户列表
  getCurrentAccountAmount: serverUrl + '/excellent/account/handle/v2/available/money', // 获取当前当户可用余额
  submitTransferAmount: serverUrl + '/excellent/account/handle/v2/remittance', // 提交划转
  getTag: serverUrl + '/excellent/account/v2/createAddress', // 冲提币，获取tag，
  recommend: serverUrl + '/excellent/web/partner/recommend/query', // 直客推荐记录
  record: serverUrl + '/excellent/web/partner/rebate/record/query', // 直客返佣记录
  recommendsummary: serverUrl + '/excellent/web/partner/recommend/summary', // 直客返佣推荐汇总
  batchCreateAddress: serverUrl + '/excellent/account/v2/batchCreateAddress', // 新增充地址
  batchFindAddress: serverUrl + '/excellent/account/v2/batchFindAddress', // 充地址列表
  importAddress: serverUrl + '/excellent/user/v2/importAddress', // 导入提币地址
  batchAddress: serverUrl + '/excellent/user/v2/batchAddress', // 新增提币地址
  batchWithdrawCoins: serverUrl + '/excellent/account/v3/batchWithdrawCoins', // 批量提
  batchSelectByUserChainName: serverUrl + '/excellent/user/v2/batchSelectByUserChainName', //提地址列表GET 
  batchDelUserChainName: serverUrl + '/excellent/user/v2/batchDelUserChainName', //删除地址 
  batchUpdateUserChainName: serverUrl + '/excellent/user/v2/batchUpdateUserChainName', //修改地址名称 
}

// 交易大赛
// const tradingContest = {
//   getActivityConfig: serverUrl + '/excellent/public/contest/activityConfig', // 活动配置时间表
//   getTeamsList: serverUrl + '/excellent/public/contest/activityTeams', // 战队列表
//   individualRegistration: serverUrl + '/excellent/contest/individualRegistration', // 个人报名
//   createTeam: serverUrl + '/excellent/contest/createTeam', // 创建战队
//   joinTeam: serverUrl + '/excellent/contest/join', // 加入战队
//   invitationJoin: serverUrl + '/excellent/contest/invitationJoin', // 分享加入战队
//   getActivityUserInfo: serverUrl + '/excellent/contest/queryActivityUserInfo', // 获取用户信息
//   getCharitableCollect: serverUrl + '/excellent/contest/charitable/v2/public/getCharitableCollect', // 获取本轮公益池金额
//   poolDonate: serverUrl + '/excellent/contest/charitable/v2/donate', // 捐赠
//   getRateOrAmount: serverUrl + '/excellent/contest/charitable/v2/getRateAndAmount', // 获取捐赠额度及比例
//   getIndividualRanking: serverUrl + '/excellent/contest/ranking/v2/public/getRanking', // 模拟和实盘个人排行榜
//   getTeamInternalRanking: serverUrl + '/excellent/contest/ranking/v2/getTeamInternalRanking', // 获取队内排行
//   getStarRanking: serverUrl + '/excellent/contest/ranking/v2/public/getStarRanking', // 获取周明星排行榜
//   // getTradingInfo: serverUrl + '/excellent/contest/queryFirmUserGain', // 合约及现货收益信息 (废弃)
//   getTeamInfo: serverUrl + '/excellent/public/contest/getTeamInfo', // 获取战队信息
//   popUpReminder: serverUrl + '/excellent/contest/popUpReminder', // 弹窗提示
// }

// 交易大赛2.0
const tradingContest = {
  // 获取活动详情
  getActivityDetail: serverUrl + '/excellent/trading/contest/activity/v2/public/getActivityDetail',
  // 获取盲盒详情
  getBlindBoxDetail: serverUrl + '/excellent/trading/contest/activity/v2/public/getBlindBoxDetail',
  // 打开盲盒
  openBlindBox: serverUrl + '/excellent/trading/contest/activity/v2/openBlindBox',
  // 获取盲盒记录
  openBlindBoxList: serverUrl + '/excellent/trading/contest/activity/v2/userOpenBlindBoxList',
  // 获取用户星星流水
  getStarsRecords: serverUrl + '/excellent/trading/contest/user/star/record',
  // 星星配置
  getStarsConfig: serverUrl + '/excellent/trading/contest/user/star/starConfig', 
  // 领星星
  getStars: serverUrl + '/excellent/trading/contest/user/star/leadingStar',
  // 超级大奖获奖记录：
  getSuperWinnerList: serverUrl + '/excellent/trading/list/of/winners/userList',
  // 获取获奖人名单
  getWinnersList: serverUrl + '/excellent/trading/list/of/winners/public/list',
  // 获取奖池金额
  getPrizePool: serverUrl + '/excellent/trading/list/of/winners/public/prizePoolInquiry',
}

/**
 * 虚拟账户账户
 */
const virtual = {
  getContractFinancialRecord:  '/contract/api/v2/trade/account/bills', // 合约记录
  getAccountList: '/excellent/account/handle/v2/catalog', // 获取币种列表
  getAllAssetBalance: '/excellent/user/v2/personalCenterPersonalInformation', // 资产总览账户余额
}

// 游戏模块
const games = {
  getGameList: serverUrl + '/excellent/game/public/list', // 获取游戏列表
  getRealGameUrl: serverUrl + '/excellent/game/getRealGameUrl', // 获取游戏链接
  getFreeGameUrl: serverUrl + '/excellent/game/getFreeGameUrl', // 获取游戏体验链接
  getFreeOptionsListUrl: serverUrl + '/excellent/options/list', //  二元期权列表 参数 pageIndex pageSize
  getSaasOptionUrl: serverUrl + '/excellent/options/getSaasOptionUrl', //  二元期权获取链接:/excellent/options/getSaasOptionUrl
}

// 体育杯
const sports = {
  getSportsList: serverUrl + "/system/sports/info/list",
  getSportsUrl: serverUrl + '/system/sports/info/splicing'
}

// 任务中心
const taskCenter = {
  getNotLoginTaskList: serverUrl + '/excellent/web/public/task/v2/getTaskList', //未登录列表
  getLoginTaskList: serverUrl + '/excellent/web/task/v2/getTaskList', // 已登录列表
  getRewardRecords: serverUrl + '/excellent/web/task/v2/getRewardRecords', // 奖励领取记录
  receiveAward: serverUrl + '/excellent/web/task/v2/receiveAward', // 用户领取奖励
  getBonusAccount: serverUrl + '/excellent/web/task/v2/getBonusAccount', // 赠金余额
}

// ieo
const startup = {
  getList: serverUrl + '/ieo/public/queryProjectList', // 活动列表
  getRecordList: serverUrl + '/ieo/queryRecordList', // 认购记录
  queryIeoProjectDetail: serverUrl + '/ieo/queryIeoProjectDetail', // 详情
  purchase: serverUrl + '/ieo/purchase', // 认购
  taskStatus: serverUrl + '/ieo/public/whetherHasProject'
}

// KYC认证 
const kyc = {
  getGameList: '/excellent/user/v2/personalCenterPersonalInformation', // 个人中心个人信息
  manageList:'/excellent/web/area/manage/v2/list', //区域
  overseasRealNameApply:'/excellent/user/web/overseasRealNameApply', //pc海外用户实名认证申请
  getFaceVerify:'/excellent/user/v2/getFaceVerify', //人脸认证结果
  updateAvatarImg:'/excellent/user/web/updateAvatarImg', //更新头像
  avatarImg:'/excellent/web/img/v2/avatarImg', //头像图片
  getAliyunInitFaceVerify:'/excellent/user/web/getAliyunInitFaceVerify', //人脸认证前获取CertifyId
  getCurrentAreaCode: serverUrl + '/excellent/web/area/manage/v2/public/phone-area-code',
}
const apis = {
  getApiList: '/excellent/quant/api/user/list',
  getApiDetail: '/excellent/quant/api/user/get',
  addApi: '/excellent/quant/api/user/add',
  editApi: '/excellent/quant/api/user/edit',
  deleteApi: '/excellent/quant/api/user/delete'
}

// 邀请返佣及盲盒
const invite = {
  getBlindBoxList: serverUrl + '/excellent/web/prize/queryUserPrize', // 盲盒明细列表
  getSwiperList: serverUrl + '/excellent/web/prize/queryPrize', // 轮播图
  getOpenBlindCount: serverUrl + '/excellent/web/prize/openNumPrize', // 查询盲盒可开次数
  getAwardsList: serverUrl + '/excellent/web/prize/queryPrizeWinner', //查询奖品明细
  getBlindBoxDetailsList: serverUrl + '/excellent/web/prize/queryUserPrizeDetails', // 盲盒明细详情列表
  openPrize: serverUrl + '/excellent/web/prize/openPrize', // 打开盲盒
  saveAwardsInfo: serverUrl + '/excellent/web/prize/address', // 保存地址
  getAwardsMsg: serverUrl + '/excellent/web/prize/queryAwardDetails', // 奖励明细
  updateCode: serverUrl + '/excellent/web/partner/rebate/code/setCode',
  addCode: serverUrl + '/excellent/web/partner/rebate/code/save',
  getCodeList: serverUrl + '/excellent/web/partner/rebate/code/list',
}
const live = {
  getLivingList: serverUrl + '/live/streaming/application/api/list', // 获取直播列表
  getUserInfo: serverUrl + '/live/streaming/anchor/application/api/getByUserId', // 获取主播信息
  getContact: serverUrl + '/live/streaming/text/config/api/get', // 联系方式
  checkTimeDuration: serverUrl + '/live/streaming/application/api/timeDetection', // 检测直播时间
  upload: serverUrl + '/live/streaming/application/api/upload', // 上传图片
  applyLiving: serverUrl + '/live/streaming/application/api/apply', // 申请直播
  getLivingRecords: serverUrl + '/live/streaming/application/api/liveRecord', // 直播记录
  getApplyRecords: serverUrl + '/live/streaming/application/api/applyRecord', // 申请记录
  getBKRoomList: serverUrl + '/live/streaming/course/video/api/list', // 小课堂列表
  getReplayById: serverUrl + '/live/streaming/course/video/api/getDetail', // 小课堂详情
  increase: serverUrl + '/live/streaming/course/video/api/increase-view', // 增加次数
  updateLiveStatus: serverUrl + '/live/streaming/application/api/updateLiveStatus', // 更新直播状态
  getLiveDetails: serverUrl + '/live/streaming/application/api/getDetail', // 直播详情
  getliveAddress: serverUrl + '/live/streaming/service/api/generate/address', // 地址
  getLivemembersmute: serverUrl + '/live/streaming/im/group/members/api/mute', // 禁可言
  getLivemembersliveCode: serverUrl + '/live/streaming/im/chat/group/api/groupInfo', // 群组信息
  getLivemembersliveSign: serverUrl + '/live/streaming/im/member/api/sign', // 登录信息
  getGroupMembersList: serverUrl + '/live/streaming/im/group/members/api/list', // 登录信息
  getRecommendItem: serverUrl + '/live/streaming/application/api/recommend'
}
/**
 是否展示红包按钮   /excellent/red/envelope/v2/isOpen
 红包活动历史列表  /excellent/red/envelope/v2/list
 进行中(即将进行)的活动 /excellent/red/envelope/v2/latestRedEnvelope
 领红包 /excellent/red/envelope/v2/openRedEnvelope
 * 
 */
const envelope = {
  isHasEnvelope: serverUrl + '/excellent/red/envelope/v2/public/isOpen', // 是否展示红包按钮
  envelopeList: serverUrl + '/excellent/red/envelope/v2/list', 
  envelopeInfo: serverUrl + '/excellent/red/envelope/v2/latestRedEnvelope',
  receiveEnvelope: serverUrl + '/excellent/red/envelope/v2/openRedEnvelope'
}


export {
  apis,
  sports,
  games,
  index,
  swap,
  fansup,
  user,
  otc,
  validate,
  redPackets,
  margin,
  financial,
  proTrading,
  task,
  newFinancial,
  earn,
  merchandiser,
  property,
  tradingContest,
  virtual,
  kyc,
  taskCenter,
  startup,
  invite,
  live,
  envelope,
  fifa
};



// WEBPACK FOOTER //
// ./src/assets/js/api.url.js